/**
 * ไฟล์ปฏิทิน (.ics) ของรอบที่จองไว้ — สร้างเป็น data URI ฝั่ง client
 * RFC 5545 ส่วนที่ต้องใช้จริงมีไม่กี่บรรทัด ไม่คุ้มลง lib หรือเพิ่ม endpoint
 * (ยกสูตรเดียวกับ bangbow-website-new-dev lib/training-ics.ts มาเพื่อให้ไฟล์ที่ผู้ใช้
 *  ได้จากสองช่องทางเป็นนัดเดียวกัน — UID = round id เพิ่มซ้ำแล้วทับ ไม่ซ้อน)
 */
export interface TrainingIcsInput {
  uid: string
  title: string
  /** YYYY-MM-DD (เวลาไทย) */
  date: string
  /** HH:mm — ไม่ส่ง = 09:00 */
  startTime?: string | null
  /** ไม่ส่ง = ยาว 90 นาทีจากเวลาเริ่ม */
  endTime?: string | null
  location?: string | null
  /** ลิงก์ห้องประชุม — ต่อท้ายคำอธิบายให้กดจากปฏิทินได้ */
  url?: string | null
}

export const buildTrainingIcs = (input: TrainingIcsInput): string => {
  // ระบุ +07:00 ให้ชัด ไม่ปล่อยให้ browser เดาจากโซนเครื่อง
  const at = (time?: string | null) =>
    new Date(`${input.date}T${(time || '09:00').slice(0, 5)}:00+07:00`)
  const stamp = (d: Date) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')

  const start = at(input.startTime)
  const end = input.endTime ? at(input.endTime) : new Date(start.getTime() + 90 * 60_000)
  const esc = (v: string) => v.replace(/([,;\\])/g, '\\$1').replace(/\r?\n/g, '\\n')

  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Bangbow//Factory Training//TH',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${input.uid}@bangbow`,
    `DTSTAMP:${stamp(start)}`,
    `DTSTART:${stamp(start)}`,
    `DTEND:${stamp(end)}`,
    `SUMMARY:${esc(input.title)}`,
    ...(input.location ? [`LOCATION:${esc(input.location)}`] : []),
    ...(input.url ? [`DESCRIPTION:${esc(`ลิงก์เข้าร่วม: ${input.url}`)}`] : []),
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n')
}

/** ดาวน์โหลดไฟล์ปฏิทินทันที */
export const downloadTrainingIcs = (input: TrainingIcsInput): void => {
  const link = document.createElement('a')
  link.href = `data:text/calendar;charset=utf-8,${encodeURIComponent(buildTrainingIcs(input))}`
  link.download = 'training.ics'
  link.click()
}
